module.exports = __webpack_public_path__ + "img/symbol_7.6ef3150d.png";